import ImageLogo from "@/assets/images/logo.png";
import { ROUTE_HOME } from "@/constants/routes.constants";
// import { Bell, LogOut, Sidebar as SidebarIcon, User } from "lucide-react";
import CustomImg from "@/components/CustomImg/CustomImg.component";
import MainDropdown from "@/infrastructure/Navbar/mainDropdown.component";
import { NetworkStatusContext } from "@/services/NetworkContext/networkStatusContext";
import { AlignJustify as SidebarIcon } from "lucide-react";
import React, { Dispatch, useContext } from "react";
import { useNavigate } from "react-router";

import { useTranslation } from "react-i18next";

type NavbarProps = {
  currPage: string;
  isSidebarOpen: boolean;
  setIsSidebarOpen: Dispatch<React.SetStateAction<boolean>>;
};

const Navbar: React.FC<NavbarProps> = ({
  currPage,
  isSidebarOpen,
  setIsSidebarOpen,
}) => {
  const { t } = useTranslation();
  const nav = useNavigate();

  const projectName = import.meta.env.VITE_PROJECT_DISPLAY_NAME;

  const { isOnline, isApiOnline, isAuthenticated } =
    useContext(NetworkStatusContext);

  return (
    <div className="bg-navbarBackground relative z-20 flex w-full items-center justify-between gap-4 p-2 shadow-sm">
      {/* SideBar Icon and Logo / Name */}
      <div className="order-1 flex items-center justify-start sm:order-1">
        <SidebarIcon
          className="mr-3 h-5 w-5 cursor-pointer"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        />
        <div className="mr-2 font-medium md:block">
          <div
            className="flex cursor-pointer flex-row flex-nowrap select-none"
            onClick={() => nav(ROUTE_HOME)}
          >
            <CustomImg
              imgSrc={ImageLogo}
              alt="Client Logo"
              className="h-8"
              loadingClass="h-8 w-12"
            />
            <div className="ml-3 text-xl font-bold">{projectName}</div>
          </div>
        </div>
      </div>
      {/* Alerts and Profile Icons */}
      <div className="order-2 flex items-center justify-end gap-3 sm:order-3">
        {/* <div className="flex gap-2 rounded-md bg-neutral-500/20 p-2">
          {isOnline ? (
            <TooltipProvider>
              <Tooltip delayDuration={150}>
                <TooltipTrigger>
                  <Wifi
                    className={`h-4 w-4 cursor-default ${
                      isApiOnline ? "!text-green-600" : "!text-orange-500"
                    } `}
                  />
                </TooltipTrigger>
                <TooltipContent>
                  <p>
                    {isApiOnline
                      ? t("Connection is Online")
                      : t("Connection is Offline")}
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            <TooltipProvider delayDuration={150}>
              <Tooltip>
                <TooltipTrigger>
                  <WifiOff className="h-4 w-4 cursor-default !text-red-600" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>{t("Internet is Offline")}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
          {isAuthenticated ? (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <BadgeCheck className="h-4 w-4 cursor-default !text-green-600" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>{t("Authenticated")}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <ShieldAlert className="h-4 w-4 cursor-default !text-red-600" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>{t("Not Authenticated")}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
        <NavbarNotifications /> */}
        <div className="">
          <MainDropdown />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
